import { GatsbyImage } from 'gatsby-plugin-image'
import styled from 'styled-components'

export const Billboard = styled(GatsbyImage)<{ zIndex?: number }>`
  z-index: ${(props) => props.zIndex ?? -1};
  position: absolute !important;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`
